import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/styles'
import {
  deleteAllDynamicApps,
  deleteDynamicApp,
  generateDynamicApps,
  getDynamicApps,
  resetDagState,
} from '../../../../redux/actions/dagActions'
import { setDataTables } from '../../../../redux/actions/dataTablesActions'
import { logoutUser } from '../../../../redux/actions/authActions'
import { Theme } from '../../../../utils/Theme'
import Header from '../../../layout/Partials/Header'
import { Link, withRouter } from 'react-router-dom'
import AccessDenied from '../../../common/AccessDenied'
import Loading from '../../../common/Loading'
import AdminLayout from '../../../layout/AdminLayout'
import moment from 'moment'
import * as Icon from 'react-feather'
import DataTable from 'react-data-table-component'
import TextFieldGroup from '../../../common/TextFieldGroup'
import {Helmet} from "react-helmet";

const styles = Theme()

class DynamicApps extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dag: {},
      errors: {},
      dynamicApps: null,
      toDelete: null,
      search_input: '',
    }
    this.updateTablePage = this.updateTablePage.bind(this)
    this.updateTableRows = this.updateTableRows.bind(this)
    this.onChange = this.onChange.bind(this)

    this.confirmDelete = this.confirmDelete.bind(this)
    this.tableActions = this.tableActions.bind(this)
    this.columns = [
      {
        name: 'App Name',
        minWidth: '350px',
        selector: 'title',
        sortable: true,
        wrap: true,
      },
      {
        name: 'App ID',
        wrap: true,
        minWidth: '350px',
        selector: 'qsApp',
        sortable: true,
      },
      {
        name: 'Users',
        selector: 'userCount',
        width: '70px',
        sortable: true,
      },
      {
        name: 'Filter Values',
        sortable: false,
        cell: row => {
          var values = ''
          for (var i = 0; i < row.filterValues.length; i++) {
            values = `${values} ${row.filterValues[i].identifier}`
            return values
          }
        },
      },

      {
        name: 'Created',
        width: '200px',
        cell: row => <p>{moment(row.date).format('Do MMMM YYYY')}</p>,
        sortable: false,
      },
      {
        name: 'Actions',
        width: '150px',
        cell: row => this.tableActions(row),
      },
    ]

    this.deleteAll = this.deleteAll.bind(this)
  }

  tableActions = row => (
    <div>
      <button
        onClick={() => this.setState({ toDelete: row._id })}
        className={`c-btn ${this.props.classes.buttonDanger} u-m-xsmall c-btn--small has-arrow u-text-center`}
      >
        <Icon.Slash size={10} /> Delete
      </button>
    </div>
  )

  componentDidMount() {
    this.props.getDynamicApps()
  }

  componentWillUnmount() {
    this.props.resetDagState()
  }

  onChange(event) {
    this.setState({ [event.target.name]: event.target.value })

    const dynamicApps = this.props.dag.dynamicApps
    const search_input = event.target.value

    for (let i = 0; i < dynamicApps.length; i++) {
      let values = ''
      for (let j = 0; j < dynamicApps[i].filterValues.length; j++) {
        values = `${values} ${dynamicApps[i].filterValues[j].identifier}`
      }
      dynamicApps[i].filterValueIdList = values
    }

    let updatedList = dynamicApps.filter(item => {
      item.userCount = item.users.length
      return (
        item.qsApp.toLowerCase().search(search_input.toLowerCase()) !== -1 ||
        item.title.toLowerCase().search(search_input.toLowerCase()) !== -1 ||
        item.filterValueIdList.toLowerCase().search(search_input.toLowerCase()) !== -1
      )
    })

    this.setState({ dynamicApps: updatedList })
  }
  updateTablePage = (page, tableName) => {
    const tables = this.props.dataTables
    tables[tableName] = {
      page,
      rows: tables[tableName] ? tables[tableName].totalRows : 20,
    }

    this.props.setDataTables(tables)
  }
  updateTableRows = (page, rows, tableName) => {
    const tables = this.props.dataTables

    tables[tableName] = {
      page,
      rows,
    }
    this.props.setDataTables(tables)
  }
  deleteAll = () => {
    this.props.deleteAllDynamicApps(this.props.dag.dynamicApps)
  }
  confirmDelete = () => {
    this.props.deleteDynamicApp(this.state.toDelete, null)
    this.setState({ toDelete: null })
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let { dag, dynamicApps, search_input } = prevState

    if (nextProps.dag) {
      if (nextProps.dag.dynamicApps && search_input === '') {
        dynamicApps = []
        nextProps.dag.dynamicApps.forEach(item => {
          item.userCount = item.users.length
          dynamicApps.push(item)
        })
      }
      dag = nextProps.dag
    }

    return { dag, dynamicApps }
  }

  render() {
    const { classes, auth, history } = this.props
    const { dag, toDelete, dynamicApps, search_input } = this.state

    return (
      <AdminLayout>
        <Helmet>
          <title>Dynamic Apps</title>
        </Helmet>
        <div className="o-page">
          <Header>
            <h2 className="c-navbar__title">Dynamic Apps</h2>
          </Header>
          {auth.isAuthenticated && auth.user.role === 'Admin' ? (
            <div className="u-m-xsmall">
              <div className={'row u-m-zero'}>
                <div className="col-md-12 col-xl-12 u-pr-zero u-pt-zero ">
                  <div className="col-md-12 col-sm-12 col-xl-12 u-mb-medium">
                    <div className="u-m-auto">
                      <div className="c-card u-p-zero u-m-zero">
                        <div className="o-line c-card__title u-p-small u-m-small">
                          <h4 className={`c-card__title ${classes.colorSecondary}`}>Dynamic Applications</h4>
                          <div className="c-dropdown dropdown">
                            <div
                              className={`c-btn ${classes.buttonPrimary} has-icon dropdown-toggle`}
                              id="MoreActionsDropdown"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              More Actions
                            </div>

                            <div
                              className="c-dropdown__menu dropdown-menu has-arrow dropdown-menu-right"
                              aria-labelledby="MoreActionsDropdown"
                            >
                              <div
                                onClick={() => {
                                  history.goBack()
                                }}
                                className="c-dropdown__item dropdown-item"
                              >
                                Back
                              </div>
                              <Link to={`/settings/dag/master-apps`} className="c-dropdown__item dropdown-item">
                                Master Apps
                              </Link>
                              <Link to={`/settings/dag/filters`} className="c-dropdown__item dropdown-item">
                                Filters
                              </Link>
                              <Link to={`/settings/pages`} className="c-dropdown__item dropdown-item">
                                Pages
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div className={'row u-m-small'}>
                          <div className={'col-md-6'}>
                            <TextFieldGroup
                              label={'Search Dynamic Apps'}
                              onChange={this.onChange}
                              name={'search_input'}
                              value={search_input}
                              placeholder={'App Name | App ID | Filter Values'}
                            />
                          </div>

                          <div className={'col-md-3 u-mt-xsmall'}>
                            <button
                              onClick={() => this.props.generateDynamicApps(this.props.history)}
                              disabled={dag.loading ? 'disabled' : false}
                              className={`c-btn c-btn--medium c-btn--fullwidth u-m-small ${classes.buttonPrimary}`}
                            >
                              Re - Sync Dynamic Apps
                            </button>
                          </div>
                          <div className={'col-md-3 u-mt-xsmall'}>
                            <button
                              onClick={this.deleteAll}
                              className={`c-btn c-btn--medium u-m-small c-btn--fullwidth ${classes.buttonDanger}`}
                            >
                              Delete All Apps
                            </button>
                          </div>
                        </div>

                        {dag.loading ? (
                          <Loading />
                        ) : dynamicApps === null || dynamicApps === undefined ? (
                          ''
                        ) : (
                          <div className="c-table-responsive">
                            {toDelete === null ? (
                              <DataTable
                                title=""
                                className={'c-table'}
                                keyField={'_id'}
                                columns={this.columns}
                                data={dynamicApps}
                                pagination
                                noHeader={true}
                                defaultSortField="title"
                                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                                paginationPerPage={20}
                                onChangePage={page => {
                                  this.updateTablePage(page, 'dynamicApps')
                                }}
                                onChangeRowsPerPage={(rows, page) => {
                                  this.updateTableRows(page, rows, 'dynamicApps')
                                }}
                              />
                            ) : (
                              <table className={'c-table'}>
                                <tbody>
                                  <tr className="c-table__row">
                                    <td className="c-table__cell" colSpan={4}>
                                      Deleting dynamic app will delete the app in Qlik Sense and also remove all users
                                      access to the App,
                                    </td>
                                    <td className="c-table__cell u-text-right">
                                      <button
                                        onClick={() => this.setState({ toDelete: null })}
                                        className={`c-btn ${classes.buttonSecondary} u-m-xsmall c-btn--small has-arrow u-text-center`}
                                      >
                                        <Icon.Slash size={10} /> Cancel
                                      </button>

                                      <button
                                        onClick={this.confirmDelete}
                                        className={`c-btn ${classes.buttonDanger} u-m-xsmall c-btn--small has-arrow u-text-center`}
                                      >
                                        <Icon.Slash size={10} /> Confirm Delete
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <AccessDenied props={{ classes, history }} />
          )}
        </div>
      </AdminLayout>
    )
  }
}

DynamicApps.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  getDynamicApps: PropTypes.func.isRequired,
  generateDynamicApps: PropTypes.func.isRequired,
  deleteAllDynamicApps: PropTypes.func.isRequired,
  deleteDynamicApp: PropTypes.func,
  auth: PropTypes.object.isRequired,
  resetDagState: PropTypes.func,
  dataTables: PropTypes.object,
  setDataTables: PropTypes.func,
  classes: PropTypes.object,
  history: PropTypes.object,
  dag: PropTypes.object,
}

const mapStateToProps = state => ({
  auth: state.auth,
  dag: state.dag,
  dataTables: state.dataTables,
})

export default connect(mapStateToProps, {
  deleteDynamicApp,
  deleteAllDynamicApps,
  logoutUser,
  generateDynamicApps,
  resetDagState,
  getDynamicApps,
  setDataTables,
})(withStyles(styles)(withRouter(DynamicApps)))
